import cloneDeep from 'lodash/cloneDeep';
import omit from 'lodash/omit';

import { baseResourceOptions } from './utils';
import createCollectionResource from 'src/actions/shared/createResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import SidekickThread from 'src/models/Sidekick/SidekickThreads';

const sidekickThreadsResource = createCollectionResource<SidekickThread>({
  name: 'sidekickThreads',
  endpoint: 'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flows/:id',
  type: SidekickThread,
  observerCreator: emptyObserverCreator,
  options: {
    ...baseResourceOptions,

    toastMessages: {
      onAddFail: () => 'There was an error while adding',
    },
    transientAttrsFn: <SidekickThread>(thread: SidekickThread): SidekickThread =>
      omit(thread!, ['updatedAtString']) as SidekickThread,
  },
  reducers: {
    addSuccess: (state, action) => {
      const items = cloneDeep(state.values);
      items.push(action.payload);
      state.values = items;
      state.persistingState = 'succeeded';
    },
  },
});

export default sidekickThreadsResource;
